<div class ="website">
<app-website-header></app-website-header>
 
<div class="container-fluid">
  <div class="container inside_pages">
  <div class="row ">
   <!-- <app-website-navbar id="sidebar" class="col-md-4 col-sm-12 col-lg-3  col-xl-3 sidebar py-4 slide-down-conten d-md-block d-none"></app-website-navbar> -->

   <nav id="sidebar" class="col-md-4 col-sm-12 col-lg-3  col-xl-3 sidebar slide-down-conten d-md-block d-none">
    <app-website-navbar></app-website-navbar>
   </nav>


   <!-- <button class="btn menu_btn d-md-none mb-4" id="sidebarToggle" (click)="toggleSidebar()">
    SideBar Menu <span class="navbar-toggler-icon"></span>
  </button>
  <nav id="sidebar" class="col-md-4 col-sm-12 col-lg-3 col-xl-3 sidebar slide-down-content"
       [style.display]="sidebarVisible ? 'block' : 'none'">
    <app-website-navbar></app-website-navbar>
  </nav>
   -->
  
  
  
   <main class=" col-lg-8 col-md-8 p-0 col-sm-12 ms-sm-auto col-lg-9 col-xl-9">
   <router-outlet></router-outlet>
   </main>
  </div>
  </div>

</div>

<app-website-footer></app-website-footer>
</div>

